import { NavLink, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FaUser } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";

import { userLogOut } from "../../store/authSlice/auth-actions";

import classes from "./SideNav.module.css";

const SideNav = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isloggedIn = useSelector((state) => state.auth.userLoggedIn);

  const logoutHandler = () => {
    dispatch(userLogOut());
    props.close();
  };
  const loginHandler = () => {
    history.push("/login");
    props.close();
  };
  return (
    <>
      <div className={classes.backdrop} onClick={props.close} />
      <div className={classes.sidenav}>
        <div className={classes.head}>
          <div className={classes.user}>
            <FaUser size={40} />
          </div>
          <button type="button" className={classes.close} onClick={props.close}>
            <FaTimes />
          </button>
        </div>
        <ul className={classes[`nav-list`]}>
          <li onClick={props.close}>
            <NavLink exactactiveClassName={classes.active} to="/">
              Home
            </NavLink>
          </li>
          <li onClick={props.close}>
            <NavLink activeClassName={classes.active} to="/collections" exact>
              Topics
            </NavLink>
          </li>
          <li onClick={props.close}>
            <NavLink
              exact
              activeClassName={classes.active}
              to="/profile"
            >
              View Profile
            </NavLink>
          </li>
          {isloggedIn ? (
            <li className={classes.auth} onClick={logoutHandler}>
              Logout
            </li>
          ) : (
            <li className={classes.auth} onClick={loginHandler}>
              Login
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

export default SideNav;
